import { Flex, Button, useBreakpointValue } from "@chakra-ui/react";
import { useMemo } from "react";

interface DotsProps {
    carouselId?: string;
    slidesToShowValue: number;
    slidesToScrollValue?: number;
    childrenCount: number;
    activeDotIndex: number;
    scrollToElement: (index: number) => void;
}

const CarouselDots = (props: DotsProps) => {
    const isMobileViewport = useBreakpointValue({ base: true, lg: false }, { ssr: true });
    const { carouselId, slidesToShowValue, childrenCount, activeDotIndex, scrollToElement } = props;
    const dotsLength = useMemo(
        () => Math.ceil(childrenCount / slidesToShowValue),
        [childrenCount, slidesToShowValue]
    );

    return (
        <Flex justifyContent="center" mt="sp32" gap="sp8">
            {Array.from({ length: dotsLength }, (_element, i) => {
                const opacity = i === activeDotIndex ? 1 : 0.35;
                return (
                    <Button
                        {...(isMobileViewport && { as: "span" })}
                        cursor="pointer"
                        variant="sliderDot"
                        borderRadius="50%"
                        className={`${carouselId}_dot`}
                        key={`${carouselId}_dot_${i}`}
                        id={`${carouselId}_dot_${i}`}
                        bg="black"
                        opacity={opacity}
                        {...(!isMobileViewport && { onClick: () => scrollToElement(i) })}
                        aria-label={`Go to slide ${i + 1}`}
                    />
                );
            })}
        </Flex>
    );
};

export default CarouselDots;
